module.controller('sampleHomeCtrl', [ '$document', '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'dateUtilService', 'sampleDataResolve', 'navigationResolve',
		'stepsResolve', 'showAnalysisResultsResolve', 'ASEBIOL_CONSTANTS', sampleHomeCtrlFn ]);

function sampleHomeCtrlFn($document, $scope, $rootScope, $state, planSamplingService, alertService, dateUtil, sampleData, navigation, steps, showAnalysisResults, ASEBIOL_CONSTANTS) {
	var vm = this;

	vm.showAnalysisResults = showAnalysisResults;

	vm.navigation = navigation;
	
	vm.title = $state.current.data.title;
	
	vm.idPlanSampling = $state.params.idPlan;
	vm.idSampling = $state.params.idSampling;
	vm.idSample = $state.params.idSample;

	vm.steps = steps;
	vm.stepCurrent = 0;

	init();

	vm.analysis = [];

	function init() {
		loadData(sampleData);
	}

	vm.reloadData = function() {
		vm.loading = true;
		planSamplingService.getSample(vm.idPlanSampling, vm.idSampling, vm.idSample).then(function(response) {
			loadData(response);
			if ($scope.refreshSample)
				$scope.refreshSample(vm.idPlanSampling, vm.idSampling, vm.idSample);
			vm.loading = false;
		}, function(response) {
			vm.loading = false;
		});
	}

	function loadData(result) {

		if (!vm.idSample || result == null)
			return;

		vm.hasAnalysisResultAnalyzed = false;

		// sampleData.then(function(response) {

		vm.sample = result.getData();

		vm.sample.scheduleDate = dateUtil.formatMomentDateTime(vm.sample.scheduleDate);

		vm.sample.planSampling.startDate = dateUtil.formatMomentDate(vm.sample.planSampling.startDate);

		vm.sample.productionArrivalDate = dateUtil.formatMomentDate(vm.sample.productionArrivalDate);

		vm.sample.expirationDate = dateUtil.formatMomentDate(vm.sample.expirationDate);

		vm.sample.takenDate = dateUtil.formatMomentDateTime(vm.sample.takenDate);

		vm.sample.productionArrivalType = vm.sample.productionArrivalType;

		var state = getConstantById(SAMPLE_STATE, vm.sample.state);

		vm.sample.className = state.className;

		vm.stepCurrent = getIndexState(state.name);

		if (vm.sample.sampleNonconforming)
			if (vm.sample.sampleNonconforming.nonconformingDate)
				vm.sample.sampleNonconforming.nonconformingDate = dateUtil.formatMomentDateTime(vm.sample.sampleNonconforming.nonconformingDate);

		var idProduct = vm.sample.sampling.product.id;

		vm.sample.samplingMethodsByProduct = [];
		vm.sample.sampleAnalysisResult.forEach(function(sar) {

			var smp = sar.technique.samplingMethods.filter(function(sm) {
				return sm.products.some(function(p) {
					return p.id == idProduct;
				})
			});

			vm.sample.samplingMethodsByProduct = vm.sample.samplingMethodsByProduct.concat(smp);

			sar.sampleAnalysisDate = dateUtil.formatMomentDateTime(sar.sampleAnalysisDate);
			vm.hasAnalysisResultAnalyzed = vm.hasAnalysisResultAnalyzed || sar.analized;
			if (sar.result) {
				sar.resultOk = true;
				var resReg = ASEBIOL_CONSTANTS.REGEX_RESULT2DECIMAL.exec(sar.result);
				if (resReg && resReg.length > 3)
					var resVal = resReg[3];
				if (sar.technique.resulttype === TECHNIQUE_TYPE.RANGE.enumName) {
					if (resVal < sar.technique.lowerRange || resVal > sar.technique.upperRange)
						sar.resultOk = false;
					sar.resultShow = sar.result + " " + sar.technique.resultTypeUnits.value;
				} else if (sar.technique.resulttype === TECHNIQUE_TYPE.UPPER_LIMIT.enumName) {
					if (resVal > sar.technique.upperLimit)
						sar.resultOk = false;
					sar.resultShow = sar.result + " " + sar.technique.resultTypeUnits.value;
				} else if (sar.technique.resulttype === TECHNIQUE_TYPE.LOWER_LIMIT.enumName) {
					if (resVal < sar.technique.lowerLimit)
						sar.resultOk = false;
					sar.resultShow = sar.result + " " + sar.technique.resultTypeUnits.value;
				} else if (sar.technique.resulttype === TECHNIQUE_TYPE.PRESENT_LACK.enumName) {
					if (resVal == 1)
						sar.resultOk = false;
					sar.resultShow = sar.result == 0 ? "Ausente" : "Presente";
				} else if (sar.technique.resulttype === TECHNIQUE_TYPE.NOT_NOTICEABLE.enumName) {
					sar.resultShow = "N/A";
				}
			}
			if (!sar.detectable) {

				sar.resultOk = false;
				sar.resultShow = "NO DETECTABLE";
			}

		});

		vm.loading = false;
		// }, function(response) {
		// vm.loading = false;
		// });
	}
	/*
	 * obtiene una arreglo de laas normativas
	 */
	vm.getRegulations = function() {
		var regs = [];
		if (angular.isUndefined(vm.sample))
			return regs;
		vm.sample.sampleAnalysisResult.forEach(function(s) {
			var reg = getById(regs, s.regulation.id);
			if (!reg)
				regs.push(s.regulation);
		});

		return regs;
	}
	/*
	 * obtiene una arreglo de laas análisis de una normativa
	 */
	vm.getAnalysis = function(idReg) {
		var analysis = [];

		vm.sample.sampleAnalysisResult.filter(function(sa) {
			return sa.regulation.id == idReg;
		}).forEach(function(s) {
			var a = getById(analysis, s.analysis.id);
			if (!a)
				analysis.push(s.analysis);
		});

		return analysis;
	}
	/*
	 * obtiene una arreglo de laas técnicas de un análisi
	 */
	vm.getTechniques = function(idAnalysis) {
		var techniques = [];

		techniques = vm.sample.sampleAnalysisResult.filter(function(sa) {
			return sa.analysis.id == idAnalysis;
		});

		return techniques;
	}

	function getById(list, id) {
		return list.find(function(l) {
			return l.id == id;
		})
	}

	function isAllLoad() {
		return loadClient && loadSite;
	}

	vm.renderTable = function(scope) {
		if (!scope.$parent.$last)
			return;
		$('#tableAnalysisSample').trigger('footable_redraw');
	}

	function getIndexState(state) {
		var s = getState(state);
		if (!s)
			return -1;
		return s.index;
	}

	function getState(state) {
		return vm.steps.find(function(s) {
			return s.name === state;
		});
	}

	vm.goTop = function() {
		$('body,html').animate({
			scrollTop : 0
		}, 800);
	}

	vm.downloadThermobuttonPdf = function() {
		planSamplingService.getThermobuttonInfo(vm.idPlanSampling, vm.idSampling, vm.idSample).then(function(response) {
			var dlnk = document.getElementById('dwnldLnk');
			vm.nameFile = "prueba.pdf";
			dlnk.href = response.getData().thermobuttonPdf;
			dlnk.click();
		}, function() {
		});
	}

	/**
	 * la muestra fur tomada
	 */
	vm.isTaken = function() {
		if (angular.isUndefined(vm.sample))
			return false;
		var state = getConstantById(SAMPLE_STATE, vm.sample.state);
		return state.id >= SAMPLE_STATE.TAKEN.id;
	}
	
	/**
	 * la muestra fur admitida
	 */
	vm.isAdmited = function() {
		if (angular.isUndefined(vm.sample))
			return false;
		
		if(vm.sample.state == "REPORTED"){
			return true;
		}
		var state = getConstantById(SAMPLE_STATE, vm.sample.state);
		return state.id >= SAMPLE_STATE.ADMITED.id;
	}

	$document.on('scroll', function() {

		// $('#imgSign').watermark({
		// text: 'GOOGLE.COM',
		// textWidth: 500,
		// gravity: 'se',
		// opacity: 1,
		// margin: 12
		// });

		if ($document.scrollTop() > 50) {
			var topButton = angular.element(document.getElementById('back-to-top'));
			topButton.fadeIn();
		} else {
			var topButton = angular.element(document.getElementById('back-to-top'));
			topButton.fadeOut();
		}

		if ($document.scrollTop() > 130) {
			var navBar = angular.element(document.getElementById('navBar'));
			navBar.fadeIn();
		} else {
			var navBar = angular.element(document.getElementById('navBar'));
			navBar.fadeOut();
		}

	});
}